
import { COPY } from './copy'
import AttendeeCard from './AttendeeCard.vue'

export default {
    components: { AttendeeCard },
    props: {
        attendees: { type: Array, required: true },
        primary: { type: Object, required: true },
        spouse: { type: Object, default: null },
        spouseAdded: { type: Boolean, default: false },
        excludeIds: { type: Array, default: () => [] },
        upcomingByClientId: { type: Object, default: () => ({}) },
    },
    data () {
        return { COPY }
    },
    computed: {
        spouseVisible () {
            return !!(this.spouse && this.primary.returning && this.primary.record)
        },
        spouseName () {
            return `${this.spouse.first_name || ''} ${this.spouse.last_name || ''}`.trim()
        },
    },
}
